import type { PortalAudience } from '@/access/portalAccess.types';
import type {
  JobsViewInput,
  DaySequencesFetchWhen,
} from '@/modules/jobs/jobs.viewInput';

export type JobDrawerWorkerSection =
  'assign' | 'viewAndAssignJobApplicantsOnly' | 'none';

export type JobDrawerView = {
  audience: PortalAudience;
  sections: {
    details: boolean;
    rate: boolean;
    worker: JobDrawerWorkerSection;
    timesheets: boolean;
  };
  actions: {
    showClientName: boolean;
    allowUnassignWorker: boolean;
    showWorkerPayRate: boolean;
  };
  query: {
    applications: { fetch: boolean };
    applicationWorkers: { fetch: boolean };
    daySequences: { fetchWhen: DaySequencesFetchWhen };
    assignedWorker: { fetch: boolean };
  };
};

export const getJobDrawerView = ({ access }: JobsViewInput): JobDrawerView => {
  const { audience, isClientPortal, canManageTenantJobs } = access;

  return {
    audience,
    sections: {
      details: true,
      rate: canManageTenantJobs,
      worker: canManageTenantJobs
        ? 'assign'
        : isClientPortal
          ? 'viewAndAssignJobApplicantsOnly'
          : 'none',
      timesheets: true,
    },
    actions: {
      showClientName: !isClientPortal,
      allowUnassignWorker: canManageTenantJobs,
      showWorkerPayRate: canManageTenantJobs,
    },
    query: {
      applications: { fetch: canManageTenantJobs || isClientPortal },
      applicationWorkers: { fetch: canManageTenantJobs || isClientPortal },
      daySequences: { fetchWhen: 'drawerOpen' },
      assignedWorker: { fetch: true },
    },
  };
};
